import { Box } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import {
  type AIFormWidgetFormValues,
  type SmartSuggestion,
} from 'hb-react/shared/components/AIFormWidget/types';
import { Textarea } from 'hb-react/shared/components/formik/components/inputs';

import { Wrapper, AIButton } from './ui';
import { SmartSuggestions } from '../SmartSuggestions';

export interface AIFormSuggestionProps {
  isSubmitting: boolean;
  placeholder?: string;
  smartSuggestions?: Array<SmartSuggestion>;
  submitForm: () => void;
  values: AIFormWidgetFormValues;
}

export const AIFormSuggestion = ({
  isSubmitting,
  values,
  submitForm,
  placeholder,
  smartSuggestions,
}: AIFormSuggestionProps) => (
  <Wrapper>
    <SmartSuggestions smartSuggestions={smartSuggestions} />
    <Textarea
      id="ai-prompt-input"
      name="aiPrompt"
      placeholder={
        placeholder ||
        s__(
          "AIForm|What do you want to create? Be specific about the content and tone you're looking for. You can generate complete content, translate to other languages, or improve existing text.",
        )
      }
      disabled={isSubmitting}
      minHeight={200}
      wrapperProps={{
        mb: 0,
        id: 'ai-prompt-wrapper',
        width: '100%',
      }}
    />
    <Box position="absolute" bottom={3} right={3}>
      <AIButton
        isLoading={isSubmitting}
        onClick={submitForm}
        isDisabled={!values.aiPrompt}
        aria-label={s__('AIForm|Get Suggestions')}
        icon={() => (
          <FontAwesomeIcon
            iconName="sparkles"
            iconType={CATEGORIES.SOLID}
            height="16px"
          />
        )}
      >
        {s__('AIForm|Get Suggestions')}
      </AIButton>
    </Box>
  </Wrapper>
);
